import { Component, OnInit, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CurrentUserService } from '../../common/current-user/current-user.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { takePendingSubscription } from '../../services/analytics/customer-analytics';
import { PosthogService } from '../../services/analytics/posthog.service';
import { SubscriptionService } from '../../services/subscription/subscription.service';
import { AdConversionsService } from '@/app/services/analytics/ad-conversions.service';

@Component({
  selector: 'app-thankyou-brand',
  imports: [DatePipe, RouterLink, CurrencyPipe],
  templateUrl: './thankyou-brand.html',
  styleUrl: './thankyou-brand.css',
})
export class ThankyouBrand implements OnInit {
  readonly currentUserService = inject(CurrentUserService);
  private readonly posthog = inject(PosthogService);
  private readonly adConversions = inject(AdConversionsService);
  private readonly subscriptionService = inject(SubscriptionService);

  ngOnInit(): void {
    if (!takePendingSubscription('brand')) {
      return;
    }
    const currency = this.subscriptionService.currencyCode()
      ?? this.currentUserService.focussedBrand?.currencyCode;
    const stripeCustomerId = this.currentUserService.focussedBrand?.stripeCustomerId;
    // Stripe only redirects here after checkout succeeded, so the card is on file.
    this.adConversions.trackCardOnFile(this.currentUserService.focussedBrand?.id, this.currentUserService.focussedBrand?.createdDate, { default_payment_method: true });
    this.posthog.posthog.capture('brand_subscription_completed', {
      ...(currency ? { currency_code: currency } : {}),
      ...(stripeCustomerId ? { stripe_customer_id: stripeCustomerId } : {}),
    });
  }

  /** Subscription summary for the card: plan name, description, price/mo, total, currency symbol */
  subscriptionSummary = computed(() => {
    const sub = this.currentUserService.currentSubscription();
    const planName = sub?.planName ?? sub?.product?.name ?? sub?.items?.[0]?.price?.product?.name ?? 'Essential Plan';
    const description = sub?.planDescription ?? sub?.product?.description ?? sub?.items?.[0]?.price?.product?.description ?? 'Perfect for brands getting started with UGC';
    const currencyCode = (sub?.currency ?? this.currentUserService.focussedBrand?.currencyCode ?? 'GBP').toUpperCase();
    const currencySymbol = currencyCode === 'USD' ? '$' : '£';
    const rawAmount = sub?.amount ?? sub?.plan?.amount ?? sub?.items?.[0]?.price?.unit_amount;
    const amount = rawAmount != null ? (typeof rawAmount === 'number' && rawAmount > 100 ? rawAmount / 100 : rawAmount) : 149;
    const total = sub?.total ?? amount;
    const totalFormatted = typeof total === 'number' && total > 100 ? total / 100 : total;
    return { planName, description, pricePerMonth: amount, total: totalFormatted, currencySymbol };
  });


  getTrialEndDate() {
    const sub = this.currentUserService.currentSubscription();
    const trialEndDate = sub?.trial_end;
    return trialEndDate ? new Date(trialEndDate * 1000).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : 'N/A';
  }

  getTotalPrice() {
    let totalPrice = 0;
    for (const item of this.currentUserService.currentSubscription().items.data) {
      totalPrice += item.price.unit_amount / 100;
    }
    return totalPrice;
  }
}
